import { Box, Stack, Typography } from "@mui/material";
import { gradients } from "../../theme/theme";

/** URAMAKS wordmark with a gradient glyph. */
export default function BrandLogo({ subtitle, compact = false }) {
  return (
    <Stack direction="row" spacing={1.25} alignItems="center">
      <Box
        sx={{
          width: 38,
          height: 38,
          borderRadius: "12px",
          background: gradients.brand,
          display: "grid",
          placeItems: "center",
          boxShadow: "0 8px 24px -8px rgba(79,124,255,0.8)",
          flexShrink: 0,
        }}
      >
        <Box
          component="svg"
          viewBox="0 0 24 24"
          sx={{ width: 22, height: 22, color: "#fff" }}
        >
          <path
            fill="currentColor"
            d="M4 5h3v8a5 5 0 0 0 10 0V5h3v8a8 8 0 0 1-16 0V5Z"
            opacity="0.95"
          />
        </Box>
      </Box>
      <Box sx={{ lineHeight: 1 }}>
        <Typography
          variant={compact ? "subtitle1" : "h6"}
          sx={{ fontWeight: 800, letterSpacing: "0.04em", lineHeight: 1 }}
        >
          URAMAKS
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
